// store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slicers/authSlice';

const store = configureStore({
  reducer: {
    //POST
    auth: authReducer,
  },
});

export default store;
